import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { theme } from '../theme'

const themeState = atom({
  key: 'themeState',
  default: theme
})

export const useThemeState = ()=>useRecoilState(themeState)
export const useThemeValue = ()=>useRecoilValue(themeState)
export const useSetThemeState = ()=>useSetRecoilState(themeState)
